function InputEdit(props) {
    return (
      <div>
        <label>{props.title}</label>
        <input id={props.name} name={props.name} type={props.type} className="w3-input w3-border" value={props.val || ""} onChange={props.onChange}/>
      </div>
    );
  }
  
  export default InputEdit;